import { render, staticRenderFns } from "./ShopsEditing.vue?vue&type=template&id=5a8b866c&scoped=true"
import script from "./ShopsEditing.vue?vue&type=script&lang=js"
export * from "./ShopsEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8b866c",
  null
  
)

export default component.exports